import { UploadedFile } from '@rasayi-workspace/shared';
import { Modal } from 'antd';
import ServerImage from 'src/app/components/shared/Image/serverImage';

interface ImagePreviewModalProps {
    visible: boolean;
    file: UploadedFile | null;
    setVisible: (val: boolean) => void;
}

const ImagePreviewModal: React.FC<ImagePreviewModalProps> = ({ visible, file, setVisible }) => {
    return (
        <Modal open={visible} footer={null} closable={true} onCancel={() => setVisible(false)} centered width={400}>
            <div className="flex justify-center items-center mt-[10px] mr-[10px]">
                <ServerImage className=" w-[400px] h-[400px]" imageClassName="!w-[100%] !h-[100%]" fileKey={file?.url || ''} alt={file?.file?.name} />
            </div>
        </Modal>
    );
};

export default ImagePreviewModal;
